import React from 'react';
import styles from './Breadcrumbs.module.css';
import ArrowIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useNavigate } from 'react-router-dom';

type Crumb = {
	text: string;
	url: string;
	domain?: 'eos' | 'spa';
	disabled?: boolean;
}

type BreadcrumbProps = {
	crumbs: Crumb[];
	onCrumbClicked?:(e: React.MouseEvent<HTMLAnchorElement>, crumb: Crumb) => void;
	lastLinkAsText?: boolean;
}

export const Breadcrumbs = (props:BreadcrumbProps) => {
	const {
		crumbs = [],
		onCrumbClicked = () => {},
		lastLinkAsText = true
	} = props;
	const navigate = useNavigate();
	const onClick = (e: React.MouseEvent<HTMLAnchorElement>, crumb: Crumb) => {
		if (crumb?.disabled) {
			e.preventDefault();
			return;
		}

		if (onCrumbClicked) onCrumbClicked(e, crumb);
		e.preventDefault();
		if (crumb.domain === 'eos') {
			window.location.href = crumb.url;
		} else {
			navigate(crumb.url);
		}
	}
	return (
		<div className={styles.container}>
			{crumbs.map((crumb, i) => {
				const isDisabled = crumb?.disabled ?? false;
				let arrows = <></>;
				if (i !== 0) {
					arrows = <span className={styles.arrows}><ArrowIcon /></span>
				}

				if (isDisabled) {
					return <span className={styles.grouped} key={i}>
						{arrows} <p key={i} className={styles.link}>{crumb.text}</p>
					</span>
				}

				return <span className={styles.grouped} key={i}>
					{arrows}
					{i === crumbs.length - 1 && lastLinkAsText ?
						<p key={i} className={styles.link}>{crumb.text}</p>:
						<a href={crumb.url} key={i} className={styles.link} onClick={(e) => onClick(e, crumb)}>{crumb.text}</a>}
				</span>
			})}
		</div>
	);
}
